import { extract, logger, svcApi, fileApi, authApi } from '.';
import { user } from '@crops';

type OverviewParam = {
  url: string;
  param: {
    pageNo: number; //페이지번호
    pageSize: number; //페이지 크기
    userNm?: string;
    userAddr?: string;
    userSggCd?: string;
    userEmdCd?: string;
    userLiCd?: string;
  };
};

type TotalParam = {
  url: string;
  param: {
    userNm?: string;
    userAddr?: string;
    userSggCd?: string;
    userEmdCd?: string;
    userLiCd?: string;
  };
};

type DetailParam = {
  url: string;
  param: {
    userIdnt: string;
  };
};

type FormData = {
  url: string;
  param: {
    regUserId: string; // 세션 아이디
    mblPhone: string; // 휴대폰 번호
    userBrdt: string; // 생년월일
    userNm: string; // 신고자명
    bizNo: string; // 사업자번호
    homePhone: string; //집번호
    userAddr: string; //신규 등록 사용자의 주소, Example : 제주 제주시 애월읍 애월북서길 52 . 1~2층
    userSggCd: string; //시군구 코드
    userSggNm?: string;
    userEmdCd: string; //읍면동 코드
    userEmdNm?: string;
    userLiCd: string; //리 코드
    userLiNm?: string;
    userIdnt?: string; //사용자고유번호
  };
};

type deleteData = {
  url: string;
  param: {
    userIdnt: string; //사용자고유번호
  };
};

type TEditUser = {
  url: string;
  param: {
    regUserId: string; // 세션 아이디
    mblPhone: string; // 휴대폰 번호
    userBrdt: string; // 생년월일
    userNm: string; // 신고자명
    bizNo: string; // 사업자번호
    homePhone: string; //집번호
    userAddr: string; //신규 등록 사용자의 주소, Example : 제주 제주시 애월읍 애월북서길 52 . 1~2층
    userSggCd: string; //시군구 코드
    userSggNm?: string;
    userEmdCd: string; //읍면동 코드
    userEmdNm?: string;
    userLiCd: string; //리 코드
    userLiNm?: string;
    userIdnt: string;
  };
};

type TAddYearData = {
  year?: string;
  prjNm?: string;
  regUserId?: string;
};

interface loginParam {
  url: string;
  token: string;
}

const UserApi = {
  ValidateToken: async (url: string, token: string) => {
    const result = await authApi.post(url, {
      access_token: token,
    });

    return result;
  },
  Logout: async (reqParam: loginParam) => {
    const result = await authApi.post(
      reqParam.url,
      {},
      {
        headers: {
          access_token: `${reqParam.token}`,
        },
      },
    );

    return result;
  },
  UserList: async (reqParam: OverviewParam) => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  UserListTotal: async (reqParam: TotalParam) => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    return extract(result);
  },
  UserListDetail: async (reqParam: DetailParam): Promise<user.UserInfo> => {
    const result = await svcApi.get(reqParam.url, {
      params: reqParam.param,
    });

    logger(result);
    return extract(result);
  },
  AddUser: async (reqParam: FormData) => {
    console.log(reqParam.param);

    const { data } = await svcApi.post(reqParam.url, reqParam.param);

    return data;
  },
  EditUser: async (reqParam: TEditUser) => {
    console.log(reqParam);

    const { data } = await svcApi.put(reqParam.url, reqParam.param);

    return data;
  },
  RemoveUser: async (reqParam: deleteData) => {
    console.log(reqParam);

    const { data } = await svcApi.delete(reqParam.url, {
      params: reqParam.param,
    });

    return data;
  },
  ReadExcel: async ({ url, prjId, file }: { url: string; prjId: string; file: File }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('prjId', prjId);

    const { data } = await fileApi.post(url, formData);

    return data;
  },
  AddExcel: async ({
    url,
    prjId,
    userId,
    jsonString,
  }: {
    url: string;
    prjId: string;
    userId: string;
    jsonString: string;
  }) => {
    const formData = new FormData();
    formData.append('jsonString', jsonString);
    formData.append('prjId', prjId);
    formData.append('userId', userId);

    const { data } = await svcApi.post(url, formData);

    return data;
  },

  AddYear: async ({ url, params }: { url: string; params: TAddYearData }) => {
    const { data } = await svcApi.post(url, null, {
      params: params,
    });

    return data;
  },
  CheckAddYear: async ({ url, year }: { url: string; year: string }) => {
    const { data } = await svcApi.get(url, {
      params: { year: year },
    });

    return data;
  },
};

export default UserApi;
